import { render, staticRenderFns } from "./house.vue?vue&type=template&id=76cc7120&"
import script from "./house.vue?vue&type=script&lang=js&"
export * from "./house.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76cc7120')) {
      api.createRecord('76cc7120', component.options)
    } else {
      api.reload('76cc7120', component.options)
    }
    module.hot.accept("./house.vue?vue&type=template&id=76cc7120&", function () {
      api.rerender('76cc7120', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/house.vue"
export default component.exports